import { render, staticRenderFns } from "./CombinationsConfiguratorCanvas.vue?vue&type=template&id=5042a8b6&scoped=true"
import script from "./CombinationsConfiguratorCanvas.vue?vue&type=script&lang=ts"
export * from "./CombinationsConfiguratorCanvas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5042a8b6",
  null
  
)

export default component.exports